import { Axios } from "../../Api/axios";
import { errorMessage } from "../Revenue/revenueApi";
import { clean } from "./payoutParts";

// Diamond withdrawals (cash-out) — backend: Admin\Wallet\AdminWithdrawalController
// + App\Services\Payments\WithdrawalService (log tag [WITHDRAW]).
//
//   GET  Admin-withdrawals?status=pending|approved|paid|rejected|legacy|all&q=&page=&limit=
//        → {status, data:[item], meta, counts:{pending,approved,paid,rejected,legacy}}
//   GET  Admin-withdrawals/{id}                      → {status, data:item}
//   POST Admin-withdrawals/{id}/approve              → {status, changed, data:item}
//   POST Admin-withdrawals/{id}/paid   {reference?, note?}
//   POST Admin-withdrawals/{id}/reject {reason}      (the diamonds go back)
//
//   pending ─approve→ approved ─paid→ paid ; pending|approved ─reject→ rejected
//   pending ─paid→ paid (approved by the same act).
// Repeating a transition = changed:false (200). A move the status does not
// allow = 409 {code: withdraw_invalid_transition | withdraw_legacy_read_only,
// current_status}. Rows from before 2026-10-22 (status `completed`) are
// legacy: read only. The admin sends the money by hand; this page records it.
// Times are unix seconds.

export const WD_TABS = [
  { key: "pending", label: "Pending" },
  { key: "approved", label: "Approved" },
  { key: "paid", label: "Paid" },
  { key: "rejected", label: "Rejected" },
  { key: "legacy", label: "Legacy" },
  { key: "all", label: "All" },
];

export const WD_STATUS_BADGE = {
  pending: { cls: "rv-badge-gold", text: "Pending" },
  approved: { cls: "rv-badge-violet", text: "Approved" },
  paid: { cls: "rv-badge-green", text: "Paid" },
  rejected: { cls: "rv-badge-red", text: "Rejected" },
  completed: { cls: "rv-badge-grey", text: "Completed (legacy)" },
};

export const KYC_BADGE = {
  allowed: { cls: "rv-badge-green", text: "KYC allowed" },
  review: { cls: "rv-badge-gold", text: "KYC in review" },
  not_allowed: { cls: "rv-badge-red", text: "KYC not allowed" },
};

/// config/withdraw.php `methods` keys.
export const METHOD_LABELS = {
  vodafone_cash: "Vodafone Cash",
  paypal: "PayPal",
  bank_account: "Bank account",
  western_union: "Western Union",
};

/// Payout detail fields (the app's form names) in display order.
export const DETAIL_FIELDS = [
  ["vodafoneCash", "Vodafone Cash number"],
  ["paypal", "PayPal"],
  ["westernUnion", "Western Union"],
  ["accountNumber", "Account number / IBAN"],
  ["name", "Full name"],
  ["email", "Email"],
  ["billingAddress", "Billing address"],
  ["creditCardLast4", "Card (last 4)"],
];

export const OPEN_STATUSES = ["pending", "approved"];

export const listWithdrawals = (params) =>
  Axios.get("/Admin-withdrawals", { params: clean(params) }).then((r) => r.data);

export const getWithdrawal = (id) => Axios.get(`/Admin-withdrawals/${id}`).then((r) => r.data?.data);

export const approveWithdrawal = (id) => Axios.post(`/Admin-withdrawals/${id}/approve`).then((r) => r.data);

export const markWithdrawalPaid = (id, { reference, note }) =>
  Axios.post(`/Admin-withdrawals/${id}/paid`, clean({ reference: reference?.trim(), note: note?.trim() })).then(
    (r) => r.data
  );

export const rejectWithdrawal = (id, reason) =>
  Axios.post(`/Admin-withdrawals/${id}/reject`, { reason: String(reason || "").trim() }).then((r) => r.data);

/// Admin-facing text for a refused transition (English admin UI — the
/// server's `message` follows the request language).
export function transitionMessage(e, fallback = "Could not update the request") {
  const status = e?.response?.status;
  const data = e?.response?.data || {};
  if (status === 409 && data.code === "withdraw_legacy_read_only") {
    return "This is a legacy request (recorded before the withdrawal queue existed) — it is read only.";
  }
  if (status === 409 && data.code === "withdraw_invalid_transition") {
    const cur = WD_STATUS_BADGE[data.current_status]?.text || data.current_status || "changed";
    return `Not allowed: this request is now “${cur}” (someone may have handled it already). The row was refreshed.`;
  }
  if (status === 404 && data.code === "withdraw_not_found") return "This request no longer exists.";
  return errorMessage(e, fallback);
}

/// Message after a 200 transition.
export function doneMessage(res, verb) {
  const st = WD_STATUS_BADGE[res?.data?.status]?.text || res?.data?.status || "";
  return res?.changed === false
    ? `Nothing changed — request #${res?.data?.id ?? ""} is already ${st.toLowerCase()}.`
    : `Request #${res?.data?.id ?? ""} ${verb}.`;
}
